import styles from "./Employee.module.scss"
import cx from "classnames"
import Image from "../../../../Image"
import React from "react"

const Employee = ({ field, employee, methods, className }) => {
  if (!employee) return null

  const { register } = methods
  const { name } = field
  const { employee_image, employee_job, title, employee_expertise } = employee

  return (
    <div className={cx(styles.employeeField, className)}>
      <input
        className={cx(styles.input, "peer")}
        type="radio"
        value={JSON.stringify(employee)}
        {...register(name)}
      />

      <div className=" w-full bg-white rounded-md px-8 py-12 peer-hover:bg-brand-turquoise peer-hover:text-white peer-checked:bg-brand-turquoise peer-checked:text-white">
        <div className="flex gap-4">
          <div>
            <div className="w-[88px] aspect-square rounded-full bg-brand-turquoise-800 overflow-hidden p-1">
              <div className="relative w-full h-full rounded-full overflow-hidden">
                {employee_image && (
                  <Image
                    alt={employee_image?.alt}
                    src={employee_image?.permalink}
                    fill
                    style={{
                      objectFit: "cover",
                      objectPosition: `${
                        employee_image?.focus_css || "center"
                      }`,
                    }}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="flex-grow">
            <div className="font-semibold text-body">{title}</div>
            <div>{employee_job}</div>
            <div className="font-body-small">{employee_expertise}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Employee
